import { render, staticRenderFns } from "./CoreMobileBottomDrawer.vue?vue&type=template&id=dbbbc832&scoped=true&"
import script from "./CoreMobileBottomDrawer.vue?vue&type=script&lang=ts&"
export * from "./CoreMobileBottomDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CoreMobileBottomDrawer.vue?vue&type=style&index=0&id=dbbbc832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbbc832",
  null
  
)

export default component.exports